<p-toast position="center"></p-toast>
<app-full-loader></app-full-loader>

<router-outlet></router-outlet>
